import MomentUtils from "@date-io/moment";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import { Box, Button, Typography } from "@mui/material";
import moment from "moment";
import { CaretDown, CaretUp, FilmSlate, Timer } from "phosphor-react";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { fget } from "../../../../API/callsAPI";
import commonStyles from "../../../../Utils/commonStyles";
import Loader from "../../../Utilities/Loader/Loader";
import UserAvatar from "../../../Utilities/UserAvatar/UserAvatar.component";
import {
  getElapsedTime,
  getElapsedTimeTwo,
} from "../../../../Utils/getElapsedTime";

const ProjectReviewsWidgetOverview = ({ projectId }) => {
  const commonClasses = commonStyles();
  const location = useLocation();
  const [expandedIndex, setExpandedIndex] = useState(0);
  const [projectReviews, setProjectReviews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());

  const getProjectReviews = async () => {
    setIsLoading(true);
    try {
      const res = await fget({
        url: `widgets/reviews/?project=${projectId}&start=${
          new Date(selectedEndDate).toISOString().split("T")[0]
        }`,
      });
      setIsLoading(false);
      setProjectReviews(res.data);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getProjectReviews();
  }, [projectId, selectedEndDate]);

  const handleOpenVersion = (review) => {
    location.pathname = review?.linked?.asset?.id
      ? `/${projectId}/assets/${review?.linked?.asset?.id}/assetversions?${btoa(
          unescape(encodeURIComponent(`versionId=${review?.linked?.id}`))
        )}`
      : `/${projectId}/sequence/${
          review?.linked?.shot?.parent_sequence?.id
        }/shots/${review?.linked?.shot?.id}/shotversions?${btoa(
          unescape(encodeURIComponent(`versionId=${review?.linked?.id}`))
        )}`;
    window.open(`${location.pathname}`);
  };

  return (
    <Box
      sx={{
        // height: "100%",
        backgroundColor: "#252A38",
        borderRadius: "20px",
        padding: "12px",
        // height: "500px",
        overflowY: "auto",
        minHeight: "450px",
      }}
    >
      <Box className={commonClasses.flexBetween}>
        <Box className={commonClasses.flexAndGap8Px}>
          <svg
            width="16"
            height="17"
            viewBox="0 0 16 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5Z"
              fill="#31BAF4"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M8 14.72C11.4352 14.72 14.22 11.9352 14.22 8.5C14.22 5.06479 11.4352 2.28 8 2.28C4.56479 2.28 1.78 5.06479 1.78 8.5C1.78 11.9352 4.56479 14.72 8 14.72ZM8 16.5C12.4183 16.5 16 12.9183 16 8.5C16 4.08172 12.4183 0.5 8 0.5C3.58172 0.5 0 4.08172 0 8.5C0 12.9183 3.58172 16.5 8 16.5Z"
              fill="#F9F9F9"
            />
          </svg>

          <Typography className={commonClasses?.widgetsTitle}>
            Project Reviews
          </Typography>
        </Box>
      </Box>
      <Box className={commonClasses.flexBetween} sx={{ mt: 1 }}>
        <Box className={commonClasses.flexAndGap8Px}>
          <div className={commonClasses.datePickerDiv}>
            <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
              <KeyboardDatePicker
                disableToolbar
                invalidDateMessage={"inValid"}
                variant="inline"
                format="DD/MM/yyyy"
                margin="normal"
                value={selectedEndDate}
                onChange={(date) => {
                  setSelectedEndDate(date);
                }}
                id="Enddate-picker"
                InputProps={{
                  disableUnderline: true,
                }}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                  style: {
                    padding: "0px",
                    color: "#606479",
                    marginLeft: "-5px",
                  },
                }}
                className={commonClasses.datePickerComponent}
                size="small"
                fullWidth={true}
              />
            </MuiPickersUtilsProvider>
          </div>
          <Button
            variant="outlined"
            sx={{
              border:
                new Date(selectedEndDate).toISOString().split("T")[0] ===
                new Date().toISOString().split("T")[0]
                  ? "2px solid #6C65D9"
                  : "2px solid transparent",
              borderRadius: "10px",
              backgroundColor: "#1B1D28",
              color: "white",
              padding: {
                md: "4px 6px",
                lg: "4px 6px",
                xl: "6px 8px",
              },
              fontSize: {
                md: "12px",
                lg: "12px",
                xl: "14px",
              },
            }}
            onClick={() => setSelectedEndDate(new Date())}
          >
            This Week
          </Button>
        </Box>
        <Typography
          sx={{
            fontSize: {
              md: "12px",
              lg: "12px",
              xl: "14px",
            },
          }}
        >
          <span
            style={{
              color: "#606479",
            }}
          >
            Count :{" "}
          </span>
          {projectReviews?.total_count}
        </Typography>
      </Box>
      {!isLoading ? (
        <>
          {projectReviews?.data?.length ? (
            <Box
              sx={{
                mt: 1,
                display: "flex",
                flexDirection: "column",
                gap: "10px",
              }}
            >
              {projectReviews?.data?.map((day, index) => {
                return expandedIndex === index ? (
                  <Box key={day?.date}>
                    <Box className={commonClasses.flexBetween} sx={{ mb: 1 }}>
                      <Box
                        className={commonClasses.flexAndGap8Px}
                        sx={{ cursor: "pointer" }}
                        onClick={() => setExpandedIndex(-1)}
                      >
                        <CaretUp weight="fill" />
                        <Typography
                          sx={{
                            fontSize: {
                              md: "12px",
                              lg: "12px",
                              xl: "14px",
                            },
                            color: "#F9F9F980",
                          }}
                        >
                          {new Intl.DateTimeFormat("en-US", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          }).format(new Date(day?.date))}{" "}
                          {new Date(day?.date).toISOString().split("T")[0] ===
                          new Date().toISOString().split("T")[0]
                            ? `(Today)`
                            : ""}
                        </Typography>
                      </Box>
                      <Typography
                        sx={{
                          fontSize: {
                            md: "12px",
                            lg: "12px",
                            xl: "14px",
                          },
                        }}
                      >
                        <span
                          style={{
                            color: "#606479",
                          }}
                        >
                          Count :{" "}
                        </span>
                        {day?.count}
                      </Typography>
                    </Box>
                    {day?.versions?.length ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                          maxHeight: "300px",
                          overflowY: "auto",
                        }}
                      >
                        {day?.versions?.map((review) => (
                          <Box
                            sx={{
                              backgroundColor: "#1B1D28",
                              padding: "6px 8px",
                              borderRadius: "10px",
                            }}
                            className={commonClasses.flexBetween}
                          >
                            <Box>
                              <Box
                                className={commonClasses.flexAndGap8Px}
                                sx={{ cursor: "pointer" }}
                                onClick={() => handleOpenVersion(review)}
                              >
                                <FilmSlate />
                                <Typography
                                  sx={{
                                    fontWeight: 600,
                                    fontSize: {
                                      md: "12px",
                                      lg: "12px",
                                      xl: "14px",
                                    },
                                  }}
                                >
                                  {review?.version_name}
                                </Typography>
                              </Box>
                              <Box className={commonClasses.flexAndGap8Px}>
                                <span
                                  className={commonClasses.statusColor}
                                  style={{
                                    backgroundColor: `rgb(${review?.linked?.status?.color})`,
                                  }}
                                />
                                <span>{review?.linked?.status?.name}</span>
                                <Timer
                                  size={20}
                                  style={{ marginLeft: "10px" }}
                                />
                                <Typography
                                  sx={{
                                    fontSize: {
                                      md: "12px",
                                      lg: "12px",
                                      xl: "14px",
                                    },
                                    color: "#F9F9F9CC",
                                    mt: "4px",
                                  }}
                                >
                                  Submitted{" "}
                                  {getElapsedTimeTwo(review?.created_at)} ago
                                </Typography>
                              </Box>
                            </Box>
                            <Box>
                              <UserAvatar
                                avatar={review?.created_by?.avatar}
                                firstName={review?.created_by?.first_name}
                                lastName={review?.created_by?.last_name}
                              />
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    ) : (
                      <Typography
                        sx={{ fontSize: "14px", color: "#606479", mt: 2 }}
                      >
                        No Reviews Found For this week
                      </Typography>
                    )}
                  </Box>
                ) : (
                  <Box className={commonClasses.flexBetween} sx={{ mb: 1 }}>
                    <Box
                      className={commonClasses.flexAndGap8Px}
                      sx={{ cursor: "pointer" }}
                      onClick={() => setExpandedIndex(index)}
                    >
                      <CaretDown weight="fill" />
                      <Typography
                        sx={{
                          fontSize: {
                            md: "12px",
                            lg: "12px",
                            xl: "14px",
                          },
                          color: "#F9F9F980",
                        }}
                      >
                        {new Intl.DateTimeFormat("en-US", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        }).format(new Date(day?.date))}{" "}
                        {new Date(day?.date).toISOString().split("T")[0] ===
                        new Date().toISOString().split("T")[0]
                          ? `(Today)`
                          : ""}
                      </Typography>
                    </Box>
                    <Typography
                      sx={{
                        fontSize: {
                          md: "12px",
                          lg: "12px",
                          xl: "14px",
                        },
                      }}
                    >
                      <span
                        style={{
                          color: "#606479",
                        }}
                      >
                        Count :{" "}
                      </span>
                      {day?.count}
                    </Typography>
                  </Box>
                );
              })}
            </Box>
          ) : (
            <Typography sx={{ fontSize: "14px", color: "#606479", mt: 2 }}>
              No Reviews For this week
            </Typography>
          )}
        </>
      ) : (
        <Loader />
      )}
    </Box>
  );
};

export default ProjectReviewsWidgetOverview;
